document.addEventListener('DOMContentLoaded', function () {
  const designButton = document.querySelector('#customers_canvas_button');
  if (!designButton) return;

  designButton.addEventListener('click', function (e) {
    e.preventDefault();

    let selectedVariantId = getSelectedVariantId();
    let quantity = getQuantity();

    if (!selectedVariantId) {
      console.error("Customers Canvas: No se pudo determinar el ID de la variante.");
      alert("Por favor selecciona las opciones del producto antes de personalizar.");
      return;
    }

    // Redirección a la vista del editor UI Framework
    window.location.href = window.location.pathname + "?view=customers-canvas-uif&variant=" + selectedVariantId + "&quantity=" + quantity;

    function getSelectedVariantId() {
      // 1. Búsqueda en el DOM para Horizon v4.1
      const variantInput = document.querySelector('input[name="id"], select[name="id"], .product-variant-id');
      if (variantInput && variantInput.value) {
        return variantInput.value;
      }

      // 2. Búsqueda en la URL de Shopify (si cambia la variante en la barra de direcciones)
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('variant')) {
        return urlParams.get('variant');
      }

      // 3. Objeto Analytics global de Shopify
      if (window.ShopifyAnalytics?.meta?.selectedVariantId) {
        return window.ShopifyAnalytics.meta.selectedVariantId;
      }

      // 4. Fallback al objeto Shopify en ventana
      if (window.Shopify?.product?.variants?.[0]?.id) {
        return window.Shopify.product.variants[0].id;
      }

      return null;
    }

    function getQuantity() {
      // Selectores de cantidad para Horizon y temas estándar
      const qtyInput = document.querySelector('input[name="quantity"], .quantity__input, quantity-input input');
      return qtyInput && qtyInput.value ? qtyInput.value : 1;
    }
  });
});